function getContactEmail() {
	switch (process.env.NEXT_PUBLIC_LANGUAGE) {
		case 'sk':
			return 'info@skippay.sk';
		case 'hu':
			return 'info@skippay.hu'; // TODO: Add right address when available
		default:
			return 'info@skippay.cz';
	}
}

function getContactEmailDPO() {
	switch (process.env.NEXT_PUBLIC_LANGUAGE) {
		case 'sk':
			return 'dpo@skippay.sk';
		case 'hu':
			return 'dpo@skippay.hu'; // TODO: Add right address when available
		default:
			return 'dpo@skippay.cz';
	}
}

function getContactPhone() {
	switch (process.env.NEXT_PUBLIC_LANGUAGE) {
		case 'sk':
			return {
				countryCode: '+421',
				number: '220512026',
			};
		case 'hu':
			return null;
		default:
			return {
				countryCode: '+420',
				number: '226288700',
			};
	}
}

export const CONTACT_EMAIL = getContactEmail();

export const CONTACT_EMAIL_DPO = getContactEmailDPO();

export const CONTACT_PHONE = getContactPhone();
